import type { BuyingListGetters } from './types';

export function useBuyingListGetters(): BuyingListGetters {
  return {};
}
